import { idsGameList } from '../../../constants/activity-constants'
import GameServices from '../../../services/game-service'
import userSessionStorage from '../../../utils/userSessionStorage'

const Store = {
  points: -1,
}
const POINTS_LEVEL = {
  snake: 100,
  tetris: 100,
  linea3: 100,
}
const gameIdRelation = {
  snake: idsGameList[0],
  tetris: idsGameList[1],
  linea3: idsGameList[2],
}
const getAuth = () => {
  let session = new userSessionStorage()
  let tokenId = session.getToken()?.idToken
  let config = {
    headers: {
      Authorization: tokenId,
    },
  }
  return config
}
export const storeGamePointstoServerSide = (point, gametype) => {
  // here send the points to be store...
  let tokenParticipationSession = sessionStorage.getItem('tokenParticipation')
  if (!tokenParticipationSession) {
    return Promise.reject({ userMessage: 'no hay token ' })
  }
  let payload = {
    point,
    tokenGame: tokenParticipationSession,
    gameId: gameIdRelation[gametype],
  }
  return GameServices.postGameParticipationSave(payload, getAuth())
}
export const requestPoints = async gametypeArray => {
  const payload = {
    idList: [].concat(gametypeArray).map(gametype => gameIdRelation[gametype]),
    startDate: '2023-01-01',
    endDate: '2024-01-01',
  }
  const result = await GameServices.getUserRankingMultiGames(payload, getAuth())
  if (result && result.data) {
    return result.data.point
  }
  return 0
}
export const getTotalPoints = async gametype => {
  // GET POINTS FROM SERVICE

  if (Store.points > 0) {
    return Store.points
  }
  Store.points = await requestPoints(gametype)
  return Store.points
}

export const getGameLevel = async gametype => {
  await getTotalPoints(gametype)
  let points = Store.points
  let pointsDivisor = POINTS_LEVEL[gametype]
  // CALC LEVEL TO SNAKE

  let level = Math.max(1, parseInt(points / pointsDivisor))

  // MAX LEVEL POSIBLE =100 min=1;
  let posibleLevel = Math.max(1, Math.min(level, 100))
  return posibleLevel
}
